(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('licences-code', {
            parent: 'admin',
            url: '/licences-code',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.licencesCode.titlePage'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/licences/licences-code.html',
                    controller: 'LicencesCodeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licencesCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('licences-code-detail', {
            parent: 'licences-code',
            url: '/detail?page',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.licencesCode.titlePage'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/licences/licences-code-detail.html',
                    controller: 'LicencesCodeDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                filter: null,
                search: {
                    value: '',
                    squash: true
                },
                vendor: {
                    id: -1
                },
                status: -1,
                domain: {
                    domainName: "All"
                },
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        search: $stateParams.search,
                        id: $stateParams.vendor.id,
                        status: $stateParams.status,
                        domain: $stateParams.domain,
                        fiter: $stateParams.filter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licencesCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('recap-objects', {
            parent: 'licences-code',
            url: '/active',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN'],
                pageTitle: 'jotApp.licencesCode.titlePage'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/licences/recap-objects.html',
                    controller: 'RecapObjectsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                search: {
                    value: '',
                    squash: true
                },
                vendor: {
                    id: -1
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        search: $stateParams.search,
                        id: $stateParams.vendor.id
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licencesCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
